<template>
    <div>
        <input-group icon="fa fa-calendar">
            <v-select ref="picker-component"
                      class='form-control'
                      v-model="selectedOption"

                      :options="options"
                      :clearable="false"

                      label='label'

                      close-on-select
            />
        </input-group>
    </div>
</template>

<script>
import moment from 'moment';
import sprintf from 'sprintf';
import resource from "@core/Util/resources";
import dateHelpers from '@modules/JourneyBuilder/Util/date-helpers';

import VSelect from 'vue-select';
import InputGroup from "@core/Components/Inputs/InputGroup";

export default {
    name: "PeriodPicker",
    components: {
        InputGroup,
        VSelect
    },
    computed: {
        selectedOption: {
            get() {
                return this.options[this.selectedOptionIndex];
            },
            set(option){
                //Our 'none' option contains a value of 'null'
                let [start, end] = (option.value || []);
                
                if(start) dateHelpers.getDateFromString(start);
                if(end) dateHelpers.getDateFromString(end);
                
                this.$emit('update:start-date', start);
                this.$emit('update:end-date', end);
                
                this.selectedOptionIndex = this.options.indexOf(option);
            }
        },
        options() {
            //Taken from marketindb-datepicker.js
            const today = moment();
            const yesterday = moment().subtract(1, 'days');

            const buildLastXDaysOption = function (daysBack) {
                return {
                    label: sprintf(resource('Datepicker_DateOptions_LastXDays'), daysBack),
                    value: [moment().subtract(daysBack, 'days'), today]
                }
            };

            return [{
                label: resource('Datepicker_DateOptions_None'),
                value: null
            }, {
                label: resource('Datepicker_DateOptions_Today'),
                value: [
                    today,
                    today
                ]
            }, {
                label: resource('Datepicker_DateOptions_Yesterday'),
                value: [yesterday, yesterday]
            }, {
                label: resource('Datepicker_DateOptions_ThisWeekSunday'),
                value: [
                    moment().startOf('isoweek').subtract(1, 'days'),
                    today
                ]
            }, {
                label: resource('Datepicker_DateOptions_ThisWeekMonday'),
                value: [
                    moment().subtract(1, 'days').startOf('isoweek'),
                    today
                ]
            }
                , buildLastXDaysOption(7)
                , {
                    label: resource('Datepicker_DateOptions_LastWeekSundaySaturday'),
                    value: [
                        moment().subtract(1, 'weeks').startOf('isoweek').subtract(1, 'days'),
                        moment().startOf('isoweek').subtract(2, 'days')
                    ]
                }, {
                    label: resource('Datepicker_DateOptions_LastWeekMondaySunday'),
                    value: [
                        moment().subtract(1, 'weeks').startOf('isoweek'),
                        moment().startOf('isoweek').subtract(1, 'days')
                    ]
                }, {
                    label: resource('Datepicker_DateOptions_LastWorkWeek'),
                    value: [
                        moment().subtract(1, 'weeks').startOf('isoweek'),
                        moment().subtract(1, 'weeks').startOf('isoweek').add(4, 'days')
                    ]
                }
                , buildLastXDaysOption(14)
                , {
                    label: resource('Datepicker_DateOptions_ThisMonth'),
                    value: [
                        moment().startOf('month'),
                        today
                    ]
                }, {
                    label: resource('Datepicker_DateOptions_LastMonth'),
                    value: [
                        moment().subtract(1, 'months').startOf('month'),
                        moment().startOf('month').subtract(1, 'days')
                    ]
                }
                , buildLastXDaysOption(31)
                , {
                    label: resource('Datepicker_DateOptions_ThisYear'),
                    value: [
                        moment().startOf('year'),
                        today
                    ]
                }
            ];

        }
    },
    data: () => ({
        selectedOptionIndex: 0
    })
}
</script>
